import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PartnersFieldsService {
  /**
   * @description
   * Services that end with an extension '-fields.service.ts'
   * are only used to write the configuration for the form builder component.
   * Here you can define all the fields as well as the layout of the form.
   */

  /**
   * * Table header
   */
  tableHeader = [
    {
      field: 'company',
      header: 'Kompanija',
    },
    {
      field: 'contact',
      header: 'Kontakt osoba',
    },
    {
      field: 'address',
      header: 'Adresa',
    },
    {
      field: 'email',
      header: 'Email',
    },
    {
      field: 'phone',
      header: 'Telefon',
    },
  ];
}
